export default "__VITE_ASSET__eeKAw6le__"